import { APIManager } from '@cjdev-internal/visual-stack-x/hooks'
import { ExecPromiseOptions } from '@cjdev-internal/visual-stack-x/hooks/useAPIManager'
import { AlternatePayee, RestApi, EnvironmentVars } from '../../../types'
import { ToastOptions } from '@cjdev-internal/visual-stack-x/components/Toast'
import * as R from 'ramda'

export const ENVS: EnvironmentVars = {
  baseUrl: process.env.REACT_APP_ADMIN_TOOL_API_URL!,
  path: process. env.REACT_APP_ALTERNATE_PAYEE_TOOL_PATH!
} as const;

export const createRestApi = (apiMan: APIManager, envs: EnvironmentVars ) => {
  const restApi: RestApi = {
    fetch: (promise: () => Promise<Response>, options?: ExecPromiseOptions) => apiMan.execAPI(promise, options),
    showNotification: (options: ToastOptions) => apiMan.toastShow(options),
    baseUrl: envs.baseUrl,
    path: envs.path
  }
  return restApi;
}


export const createRedirectForbiddenErrorPage = (onUnauthorized: () => void) => {
  return (isForbiddenStatus: boolean) => {
    if(isForbiddenStatus){
      console.warn('Unauthorized access detected')
      onUnauthorized()
      return
    }
    return
  }
}

export const sanitizeBody = (data: AlternatePayee, type: string) => {
  const propertiesToOmit = 'PUT'.includes(type) ? ['lastModified'] : ['id', 'lastModified']
  const bodySanitized = R.omit(propertiesToOmit, data)
  const ap = { alternatePayee: bodySanitized }
  return ap
}